var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTopMenu = function SvgTopMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 16,
    viewBox: "0 0 4 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.315 6.5A1.75 1.75 0 1 1 .5 8.25 1.783 1.783 0 0 1 2.315 6.5zm0 6a1.75 1.75 0 1 1-1.814 1.75 1.783 1.783 0 0 1 1.815-1.75zM.502 2.207A1.75 1.75 0 0 1 4 2.25 1.787 1.787 0 0 1 2.185 4 1.75 1.75 0 0 1 .5 2.207z"
  })));
};
export default SvgTopMenu;